// extracted by mini-css-extract-plugin
export var button = "styles-module__button___QeZMv";
export var fallbackContainer = "styles-module__fallbackContainer___MtTxG";